import React, { FC, MutableRefObject } from "react";
import classNames from "classnames";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Link } from "@app/components/common/link/Link";
import { INavigationMenuItem } from "@app/models/storyblok/datasource";

type Props = {
  isCollapsed: boolean;
  data: INavigationMenuItem[];
  navRef: MutableRefObject<HTMLDivElement>;
  lastItemRef: MutableRefObject<HTMLDivElement>;
  setActiveMenuGroup: (menuGroup: string) => void;
};

export const FullNavigation: FC<Props> = ({
  isCollapsed,
  data,
  navRef,
  lastItemRef,
  setActiveMenuGroup,
}) => {
  const { language, defaultLanguage } = useI18next();

  return (
    <>
      <nav
        className={classNames(
          "flex items-center gap-x-9 py-7 text-small text-primary-content",
          {
            "pointer-events-none invisible shrink": isCollapsed,
          },
        )}
        ref={navRef}
      >
        {data.map((navigationEntry, index) => (
          <div
            key={navigationEntry.id}
            ref={index === data.length - 1 ? lastItemRef : null}
            onMouseEnter={() => setActiveMenuGroup(navigationEntry.id)}
          >
            <Link
              to={navigationEntry.ref}
              className="whitespace-nowrap no-underline duration-300 hover:text-nav"
              onClick={() => setActiveMenuGroup(null)}
            >
              {navigationEntry.name[language] ??
                navigationEntry.name[defaultLanguage]}
            </Link>
          </div>
        ))}
      </nav>
    </>
  );
};
